export default Object.freeze({
  Pending: 1,
  Processing: 2,
  Processed: 3,
  Error: 4,
  Skipped: 5,
  Cancelled: 6,
  Failed: 7,
});
